import gql from 'graphql-tag';

export const userFragment = gql`
  fragment UserFragment on currentUser {
    id
    email
    emailNotifications
    givenName
    middleName
    surname
    fullName
    title
    phoneNumber
    profileImage
    slackNotifications
    smsNotifications
    i18nPrefs {
      dateFormat
      timeFormat
      numGroupSeparator
      decimal
    }
  }
`;

export const searchOptionsVizFragmentName = 'searchOptionsVizFragment';
export const searchOptionsVizFragment = gql`
  fragment ${searchOptionsVizFragmentName} on DatasetVisualization {
    tags
    chartType
    datasetId
  }
`;

export const searchOptionsDatasetFragmentName = 'searchOptionsDatasetFragment';
export const searchOptionsDatasetFragment = gql`
  fragment ${searchOptionsDatasetFragmentName} on Dataset {
    id
    name
  }
`;

export const ADD_VISUALIZATION_QUERY_NAME = 'addVisualization';

export const allOptionsFragmentName = 'allOptionsFragment';
export const allOptionsFragment = gql`
  fragment ${allOptionsFragmentName} on DatasetVisualization {
    id
    name
    datasetId
    options {
      key
      value
    }
  }
`;

export const datasetFragmentName = 'datasetFragment';
export const datasetFragment = gql`
  fragment ${datasetFragmentName} on Dataset {
    ...${searchOptionsDatasetFragmentName}
    creator
    description
    creatorName
    createdOn
    updatedByName
    updatedOn
    updatedBy
    editMode
    isDeletable
    datasetStatusType
    parentDataset {
      id
      name
    }
    attributes {
      index
      name
      displayName
      description
      attributeType
      defaultAggregation
      hidden
      available
      aggregateMeasure
      formatType
      ordinalAttribute
      annotations {
        key
        value
      }
      calculation
    }
    annotations {
      key
      value
    }
  }
  ${searchOptionsDatasetFragment}
`;

export const visualizationFragmentName = 'visualizationFragment';
export const visualizationSummaryFragment = gql`
  fragment ${visualizationFragmentName} on DatasetVisualization {
    ...${allOptionsFragmentName}
    ...${searchOptionsVizFragmentName}
    isPrivate
    creatorName
    creator
    createdOn
    updatedByName
    updatedOn
    canDelete
    canUpdate
    commitMessage
    layout {
      id
      fields
    }

    dataset {
      ...${datasetFragmentName}
    }
  }
  ${allOptionsFragment}
  ${searchOptionsVizFragment}
  ${datasetFragment}
`;

export const visualizationFragment = gql`
  fragment ${visualizationFragmentName} on DatasetVisualization {
    ...${allOptionsFragmentName}
    ...${searchOptionsVizFragmentName}
    isPrivate
    creatorName
    creator
    createdOn
    updatedByName
    updatedOn
    canDelete
    canUpdate
    commitMessage
    revisions {
      version
      commitMessage
      updatedByName
      updatedOn
    }
    layout {
      id
      fields
    }

    dataset {
      ...${datasetFragmentName}
    }
  }
  ${allOptionsFragment}
  ${searchOptionsVizFragment}
  ${datasetFragment}
`;
export const visualizationFragmentOld = gql`
  fragment ${visualizationFragmentName} on DatasetVisualization {
    id
    name
    chartType
    isPrivate
    datasetId
    creatorName
    creator
    createdOn
    updatedByName
    updatedOn
    canDelete
    canUpdate
    commitMessage
    revisions {
      version
      commitMessage
      updatedByName
      updatedOn
    }
    layout {
      id
      fields
    }
    options {
      key
      value
    }
    tags

    dataset {
      ...${datasetFragmentName}
    }
  }
  ${datasetFragment}
`;
